/** Marcador reservado para mensagens comuns das abas de cadastro. */
export const FORM_SUMMARY = null;

/** Número em pt-BR sem casas fixas (valores de cadastro: 0,2501 / 1000). */
export const num = (v: number | undefined | null, digits = 4) =>
  v === undefined || v === null
    ? '–'
    : new Intl.NumberFormat('pt-BR', { maximumFractionDigits: digits }).format(v);
